import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { oli_product_users_get_with_project_data, oli_project_newUser } from "../services/apiService";
import LogoutButton from '../components/LogoutButton';
import xoroLogo from "../assects/img/X_logo.png";
type NewData = {
  domainType: string;
  icpType: string;
  orgName: string;
  username: string;
  email: string;
  userInfo: string;
  callSummary: string;
};

function OliUsersPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const project_id = searchParams.get("id") || "";

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [customersData, setCustomersData] = useState([]);
  const [domainOptions, setDomainOptions] = useState<any[]>([]);
  const [icpOptions, setIcpOptions] = useState<any[]>([]);
  const [vpsOptions, setVpsOptions] = useState<any[]>([]);

  const [newData, setNewData] = useState<NewData>({
    domainType: "",
    icpType: "",
    orgName: "",
    username: "",
    email: "",
    userInfo: "",
    callSummary: "",
  });

  const [vpsCategories, setVpsCategories] = useState<Record<number, string>>({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [current_user_chat_code] = useState("");

  const CATEGORY_OPTIONS = ["Cannot live without it", "Nice to have", "Not my problem"];

  const handleFormChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setNewData((prev) => ({ ...prev, [name]: value }));
  };

  const filteredCustomers = customersData.filter(
    (c: any) =>
      (c.username || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (c.email || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage) || 1;
  const paginatedCustomers = filteredCustomers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleRowClick = (id: number, username: string) => {
    navigate(`/oliCallTracking/?id=${id}`);
    localStorage.setItem('userName', username);
  };

  async function getAll() {
    setLoading(true);
    try {
      const response = await oli_product_users_get_with_project_data(Number(project_id));
      if (response?.status !== "No users found") {
        setCustomersData(response.usersDetails || []);
      } else {
        setCustomersData([]);
      }
      setDomainOptions(response?.domains || []);
      setIcpOptions(response?.icps || []);
      setVpsOptions(response?.vps || []);
      setVpsCategories({});
    } catch (e) {
      console.error(e);
      setCustomersData([]);
      setDomainOptions([]);
      setIcpOptions([]);
      setVpsOptions([]);
      setVpsCategories({});
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAll();
  }, [project_id]);

  const handleFormSubmit = async () => {
    setLoading(true);

    const required: (keyof NewData)[] = [
      "domainType",
      "icpType",
      "orgName",
      "username",
      "email",
    ];
    const missing = required.filter((k) => !newData[k]);
    if (missing.length) {
      alert("Please fill all required fields.");
      setLoading(false);
      return;
    }

    const missingVp = (vpsOptions || []).some((vp: any) => !vpsCategories[vp.id]);
    // if (vpsOptions.length > 0 && missingVp) {
    //   alert("Please select a category for each Value Proposition.");
    //   setLoading(false);
    //   return;
    // }

    try {
      const formData = new FormData();
      formData.append("username", newData.username);
      formData.append("domainType", newData.domainType);
      formData.append("icpType", newData.icpType);
      formData.append("orgName", newData.orgName);
      formData.append("email", newData.email);
      formData.append("userInfo", newData.userInfo);
      formData.append("callSummary", newData.callSummary);
      formData.append("user_chat_id", current_user_chat_code);
      formData.append("project_id", String(project_id || ""));
      formData.append("vps", JSON.stringify(vpsCategories));

      await oli_project_newUser(formData);

      setShowModal(false);
      setNewData({
        domainType: "",
        icpType: "",
        orgName: "",
        username: "",
        email: "",
        userInfo: "",
        callSummary: "",
      });
      setVpsCategories({});
      await getAll();
      alert("Customer created successful");
    } catch (err) {
      console.error("Upload failed", err);
      alert("Customer creation failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20">
      {/*Professional Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-gray-200/60 shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/*Brand & Title */}
            <div className="flex items-center space-x-4">
              <div className="flex-shrink-0">
                {/*  <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-sm ring-1 ring-blue-600/20">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div> */}
                <div className="p-2.5 bg-white rounded-xl shadow-lg border border-gray-200/50">
                  <img
                    src={xoroLogo}
                    alt="Avironix Logo"
                    className="w-6 h-6 object-cover rounded-full"
                  />
                </div>
              </div>
              <div>
                <h1 className="text-xl font-semibold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                  OLI
                </h1>
                <p className="text-sm text-gray-500 font-medium">Powered by XORO Story</p>
              </div>
            </div>

            {/*User Info & Actions */}
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-semibold text-gray-900">
                  {localStorage.getItem('oli_username')}
                </p>
                <p className="text-xs text-blue-600 font-medium">Administrator</p>
              </div>
              {/* <div className="w-8 h-8 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center ring-2 ring-white">
              <span className="text-xs font-semibold text-gray-700">
                {localStorage.getItem('oli_username')?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div> */}
              <LogoutButton />
            </div>
          </div>
        </div>
      </header>

      {/*Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/*Page Header with Actions */}
        <div className="mb-8">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl flex items-center justify-center ring-1 ring-blue-200/50">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-3xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-clip-text text-transparent">
                    {localStorage.getItem('oli_product')}
                  </h2>
                  <p className="text-sm text-gray-500 font-medium">Product Customers</p>
                </div>
              </div>

              <div className="flex items-center space-x-4 text-sm">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                  <span className="text-gray-600">
                    {customersData.length} {customersData.length === 1 ? 'customer' : 'customers'}
                  </span>
                </div>
                <div className="w-1 h-4 bg-gray-300 rounded-full"></div>
                <span className="text-gray-500">Active management</span>
              </div>
            </div>
            <div className="mt-6 sm:mt-0 flex space-x-3">
              <button
                onClick={() => { window.history.back(); }}
                className="inline-flex items-center px-4 py-2 border border-gray-300/60 text-sm font-medium rounded-xl text-gray-700 bg-white/80 backdrop-blur-sm hover:bg-white hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Back to Products
              </button>
              <button
                onClick={() => setShowModal(true)}
                className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add Customer
              </button>
            </div>
          </div>

          {/*Search Bar */}
          <div className="mt-8">
            <div className="max-w-md">
              <label htmlFor="search" className="sr-only">Search customers</label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  id="search"
                  placeholder="Search by username or email..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="block w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl leading-5 bg-white/80 backdrop-blur-sm placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm hover:shadow-md"
                />
              </div>
            </div>
          </div>
        </div>

        {/*Customers Grid */}
        {paginatedCustomers.length !== 0 ? (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {paginatedCustomers.map((customer: any, index: number) => (
              <div
                key={customer.id}
                onClick={() => handleRowClick(customer.id, customer.username)}
                className="group relative bg-white/80 backdrop-blur-sm rounded-2xl border border-gray-200/60 p-6 hover:shadow-xl hover:shadow-blue-100/50 hover:border-blue-300/40 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
              >
                {/*Background Pattern */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 to-indigo-50/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/*Customer Header */}
                <div className="relative flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl flex items-center justify-center group-hover:from-blue-200 group-hover:to-blue-300 transition-all duration-200">
                        {customer.username ? (
                          <span className="text-lg font-bold text-blue-700">
                            {customer.username.charAt(0).toUpperCase()}
                          </span>
                        ) : (
                          <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        )}
                      </div>
                      <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full border-2 border-white flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-700 transition-colors duration-200">
                        {customer.username}
                      </h3>
                      <div className="w-0 group-hover:w-12 h-0.5 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-300"></div>
                    </div>
                  </div>
                  <svg className="w-5 h-5 text-gray-400 group-hover:text-blue-500 group-hover:translate-x-1 transition-all duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
                {/*Customer Email */}
                <div className="relative mb-4">
                  <p className="text-sm text-gray-600 flex items-center group-hover:text-gray-700 transition-colors duration-200">
                    <svg className="w-4 h-4 mr-2 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    {customer.email}
                  </p>
                </div>



                {/*Customer Info */}
                <div className="relative mb-4">
                  <p className="text-sm text-gray-600 leading-relaxed line-clamp-2 group-hover:text-gray-700 transition-colors duration-200">
                    {customer.user_info || "No additional information available"}
                  </p>
                </div>

                {/*Status and Actions */}
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full animate-pulse"></div>
                    <span className="text-xs text-gray-500 font-medium">Active Customer</span>
                  </div>
                  <div className="flex items-center space-x-1 text-xs text-blue-600 font-medium opacity-0 group-hover:opacity-100 transition-all duration-200">
                    <span>View Details</span>
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </div>
                </div>

                {/*Hover Glow Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-600/5 to-indigo-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            ))}
          </div>
        ) : (
          /*Empty State */
          <div className="text-center py-16 bg-white/60 backdrop-blur-sm rounded-2xl border border-gray-200/60 shadow-sm">
            <div className="max-w-md mx-auto">
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center">
                <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">No customers found</h3>
              <p className="text-gray-500 mb-8 leading-relaxed">Start building your customer base by adding your first customer to this product.</p>
              <button
                onClick={() => setShowModal(true)}
                className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Add Your First Customer
              </button>
            </div>
          </div>
        )}

        {/*Pagination */}
        <div className="mt-8 flex items-center justify-between bg-white/60 backdrop-blur-sm rounded-xl p-4 border border-gray-200/60">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            className="inline-flex items-center px-4 py-2 border border-gray-300/60 text-sm font-medium rounded-lg text-gray-700 bg-white/80 hover:bg-white hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 backdrop-blur-sm"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Previous
          </button>

          <div className="flex items-center space-x-2">
            <span className="text-sm text-gray-700 font-medium">
              Page <span className="font-bold text-blue-600">{currentPage}</span> of{" "}
              <span className="font-bold text-blue-600">{totalPages}</span>
            </span>
            <div className="flex items-center space-x-1">
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                const page = i + 1;
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-2 h-2 rounded-full transition-all duration-200 ${currentPage === page
                        ? 'bg-blue-600 w-6'
                        : 'bg-gray-300 hover:bg-gray-400'
                      }`}
                  />
                );
              })}
            </div>
          </div>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            className="inline-flex items-center px-4 py-2 border border-gray-300/60 text-sm font-medium rounded-lg text-gray-700 bg-white/80 hover:bg-white hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 backdrop-blur-sm"
          >
            Next
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </main>

      {/*Modal for New Customer */}
      {showModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            {/*Background overlay */}
            <div
              className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity"
              onClick={() => setShowModal(false)}
            />

            {/*Modal panel */}
            <div className="relative inline-block align-bottom bg-white/95 backdrop-blur-sm rounded-2xl px-6 pt-6 pb-6 text-left overflow-hidden shadow-2xl border border-gray-200/60 transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
              {/*Header */}
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                    Add New Customer
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">Fill in the customer details to get started</p>
                </div>
                <button
                  onClick={() => setShowModal(false)}
                  className="rounded-xl text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-2 transition-all duration-200"
                >
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              {/* Form */}
              <div className="space-y-6">
                {/* Form Grid Container */}
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                  {/* Left Column */}
                  <div className="space-y-5">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Domain Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="domainType"
                        value={newData.domainType}
                        onChange={handleFormChange}
                        className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 h-12"
                      >
                        <option value="">Select a Domain</option>
                        {domainOptions.map((d: any) => (
                          <option key={d.id} value={d.domain}>{d.domain}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        ICP Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="icpType"
                        value={newData.icpType}
                        onChange={handleFormChange}
                        className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 h-12"
                      >
                        <option value="">Select an ICP</option>
                        {icpOptions.map((i: any) => (
                          <option key={i.id} value={i.icp}>{i.icp}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Organization Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="orgName"
                        value={newData.orgName}
                        onChange={handleFormChange}
                        className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 h-12 px-4"
                        placeholder="Enter organization name"
                      />
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-5">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Username <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="username"
                        value={newData.username}
                        onChange={handleFormChange}
                        className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 h-12 px-4"
                        placeholder="Enter username"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Email <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={newData.email}
                        onChange={handleFormChange}
                        className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 h-12 px-4"
                        placeholder="Enter email address"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 h-12 px-4"
                        placeholder="Enter phone number"
                      />
                    </div>
                  </div>
                </div>

                {/* Full Width Additional Info */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Additional Information
                  </label>
                  <textarea
                    name="userInfo"
                    value={newData.userInfo}
                    onChange={handleFormChange}
                    rows={4}
                    className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 bg-white/80 backdrop-blur-sm sm:text-sm transition-all duration-200 resize-none p-4"
                    placeholder="Enter any additional customer information, notes, or special requirements..."
                  />
                  <p className="mt-2 text-xs text-gray-500">
                    Provide any relevant details about the customer's needs, preferences, or account notes.
                  </p>
                </div>
              </div>



              {/* Footer */}
              <div className="mt-8 flex items-center justify-end space-x-3">
                <button
                  onClick={() => setShowModal(false)}
                  className="inline-flex items-center px-5 py-2.5 border border-gray-300/60 text-sm font-medium rounded-xl text-gray-700 bg-white/80 hover:bg-white hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 backdrop-blur-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={handleFormSubmit}
                  className="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add Customer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Loading Overlay */}
      {loading && (
        <div className="fixed inset-0 z-50 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-2xl p-8 flex items-center space-x-4 shadow-2xl border border-gray-200/60">
            <div className="relative">
              <svg className="animate-spin h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
              </svg>
              <div className="absolute inset-0 rounded-full bg-blue-600/20 animate-ping"></div>
            </div>
            <div>
              <span className="text-gray-700 font-semibold text-lg">Processing</span>
              <p className="text-gray-500 text-sm">Please wait a moment...</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );

}

export default OliUsersPage;
